import React from 'react';
import {
  Box,
  CircularProgress,
  Divider,
  Drawer,
  IconButton,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const describeChange = (entry) => {
  const before = entry.oldValue || {};
  const after = entry.newValue || {};
  const fields = Object.keys(after);
  if (!fields.length) return 'No fields recorded';
  return fields
    .map((field) => {
      const from = JSON.stringify(before[field]);
      const to = JSON.stringify(after[field]);
      return `${field}: ${from} → ${to}`;
    })
    .join('\n');
};

/**
 * The release log for one flag.
 *
 * This is not a debugging aid. A deploy leaves a git tag; a release does not, because it
 * is a database write against a commit that may be weeks old. These rows are the only
 * record of when a feature actually became visible to schools, and who decided that.
 */
const AuditDrawer = ({ open, node, entries, loading, onClose }) => {
  const key = node && node.node && node.node.row ? node.node.row.key : undefined;

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box width={480} role="presentation">
        <Box display="flex" alignItems="center" p={2}>
          <Box flex={1}>
            <Typography variant="h6">Release log</Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ fontFamily: 'monospace' }}>
              {key}
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />

        {loading && (
          <Box p={4} display="flex" justifyContent="center">
            <CircularProgress size={24} />
          </Box>
        )}

        {!loading && (!entries || entries.length === 0) && (
          <Box p={3}>
            <Typography variant="body2" color="textSecondary">
              No changes recorded yet. This flag is still at the state it was created with.
            </Typography>
          </Box>
        )}

        {!loading &&
          (entries || []).map((entry) => (
            <Box key={entry._id} px={3} py={2} borderBottom="1px solid #eceff1">
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                {new Date(entry.createdAt).toLocaleString()}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {entry.source}
                {entry.changedByType ? ` · ${entry.changedByType}` : ''}
                {entry.changedBy ? ` · ${entry.changedBy}` : ' · no principal'}
              </Typography>
              {/* Set only on rows written by a propagated sync, naming the environment the
                  operator actually called. Without it, "created in production by a sync
                  triggered from staging" is indistinguishable from someone acting here. */}
              {entry.originEnvironment && (
                <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
                  triggered from {entry.originEnvironment}
                </Typography>
              )}
              <Box
                mt={1}
                style={{
                  fontFamily: 'monospace',
                  fontSize: 12,
                  whiteSpace: 'pre-wrap',
                  background: '#f8f9fa',
                  padding: 8,
                  borderRadius: 4,
                }}>
                {describeChange(entry)}
              </Box>
              {entry.reason && (
                <Typography variant="body2" style={{ marginTop: 6 }}>
                  “{entry.reason}”
                </Typography>
              )}
            </Box>
          ))}
      </Box>
    </Drawer>
  );
};

export default AuditDrawer;
